import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const IsNotSaved = _ref => {
  let {
    isNotSaved,
    save,
    paramsForUpdate
  } = _ref;
  const {
    t
  } = useTranslation();
  return isNotSaved && /*#__PURE__*/React.createElement("div", {
    style: {
      float: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: () => save(...paramsForUpdate),
    className: "ms-auto me-3"
  }, t('click_to_save')));
};
export default IsNotSaved;